export default (Vue) => {
  Vue.directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function(el) {
      // console.log(el)  在这里打印出el看看传过来的el到底是什么，以下代码就是为了判断是不是绑定到了我想绑定的元素上
      if (el.tagName.toLocaleLowerCase() == 'textarea') {
        el.focus()
      } else {
        if (el.getElementsByTagName('textarea')) {
          el.getElementsByTagName('textarea')[0].focus()
        }
      }

    }
  })
  Vue.directive('color', {
    // 当被绑定的元素插入到 DOM 中时……
    bind: function(el, binding) {
      if (el.tagName.toLocaleLowerCase() == 'textarea') {
        el.style.color = binding.value
      }
      
    }
  })

}
